import PermissionReadAccess from 'owa-service/lib/contract/PermissionReadAccess';
import PermissionActionType from 'owa-service/lib/contract/PermissionActionType';
import PermissionLevelType from 'owa-service/lib/contract/PermissionLevelType';

// Type alias for defining properties for permission object
type PermissionPropertyType =
    | 'CanCreateItems'
    | 'CanCreateSubFolders'
    | 'DeleteItems'
    | 'EditItems'
    | 'IsFolderContact'
    | 'IsFolderOwner'
    | 'IsFolderVisible'
    | 'ReadItems'
    | 'PermissionLevel';

// Type for defining object for storing permission properties string constants
type PermissionPropertyConstantType = {
    [key: string]: PermissionPropertyType;
};

// Type for defining object for storing permission level string constants
type PermissionLevelConstantType = {
    [key: string]: PermissionLevelType;
};

// Type for defining object for storing permission read access string constants
type ReadAccessConstantType = {
    [key: string]: PermissionReadAccess;
};

// Type for defining object for storing permission edit/delete access string constants
type EditAccessConstantType = {
    [key: string]: PermissionActionType;
};

// Read access string contants
const READ_ACCESS: ReadAccessConstantType = {
    FULL_DETAILS: 'FullDetails',
    NONE: 'None',
};

// Edit/delete access string contants
const EDIT_ACCESS: EditAccessConstantType = {
    ALL: 'All',
    NONE: 'None',
    OWNED: 'Owned',
};

// Permission level string contants
const PERMISSION_LEVEL_TYPE: PermissionLevelConstantType = {
    OWNER: 'Owner',
    PUBLISHING_EDITOR: 'PublishingEditor',
    EDITOR: 'Editor',
    PUBLISHING_AUTHOR: 'PublishingAuthor',
    AUTHOR: 'Author',
    NONEDITING_AUTHOR: 'NoneditingAuthor',
    REVIEWER: 'Reviewer',
    CONTRIBUTOR: 'Contributor',
    NONE: 'None',
    CUSTOM: 'Custom',
};

// Pemrission properties string contants
const PROPERTY: PermissionPropertyConstantType = {
    CAN_CREATE_ITEMS: 'CanCreateItems',
    CAN_CREATE_SUB_FOLDERS: 'CanCreateSubFolders',
    DELETE_ITEMS: 'DeleteItems',
    EDIT_ITEMS: 'EditItems',
    IS_FOLDER_CONTACT: 'IsFolderContact',
    IS_FOLDER_OWNER: 'IsFolderOwner',
    IS_FOLDER_VISIBLE: 'IsFolderVisible',
    READ_ITEMS: 'ReadItems',
    PERMISSION_LEVEL: 'PermissionLevel',
};

export default {
    PROPERTY,
    EDIT_ACCESS,
    READ_ACCESS,
    PERMISSION_LEVEL_TYPE,
};
